import React, { useState } from "react";
import LibraryNavigationPage from "./LibraryNavigationPage";

const LibraryPage: React.FC = () => {
    const [activeSection, setActiveSection] = useState<string>("");

    return(
      <LibraryNavigationPage activeSection={activeSection} setActiveSection={setActiveSection} />
    );
};

export default LibraryPage;